import { render, staticRenderFns } from "./ResellerViewRoles.vue?vue&type=template&id=4b1c6ca9"
import script from "./ResellerViewRoles.vue?vue&type=script&lang=js"
export * from "./ResellerViewRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports